module.exports = __webpack_public_path__ + "img/2.1db868e3.png";